<template>
    <v-flex direction="column">
        <v-flex class="flex-shrink-0 p-4 border-bottom" justify="center">
            <a class="header-link" href="https://joinladder.com">
                <Wordmark class="logo" />
            </a>
        </v-flex>
        <div class="content py-5">
            <router-view />
        </div>
        <ladder-footer :powered="false" class="border-top" />
    </v-flex>
</template>

<script>
import Wordmark from "@/components/Wordmark";
import LadderFooter from "@/components/LadderFooter";

export default {
    name: "LegalLayout",
    components: {
        Wordmark,
        LadderFooter
    },
    created() {
        document.body.classList.add("light");
    },
    beforeDestroy() {
        document.body.classList.remove("light");
    }
};
</script>

<style lang="scss" scoped>
.content {
    width: 80%;
    margin: 0 auto;
}
.header-link {
    color: $dark;
    width: 180px;
    text-align: center;
    font-weight: bold;
    text-decoration: none;
    transition: color 300ms ease;
}
.header-link:hover {
    text-decoration: none;
    color: $primary !important;
}
.logo {
    height: 1.5rem;
}
</style>
